const USER_ADMIN = 'user-admin';
const LISTING_ADMIN = 'listing-admin';
const EVENT_ADMIN = 'event-admin';

export const endpoints = {
  user: {
    users: `users`,
    newUsers: `${USER_ADMIN}/new-users`,
    userId: `users/user/id`,
    adminUsers: `admin-users`,
    retiredUserAdmin: `retired-users`,
    dataCleanse: `${USER_ADMIN}/data-cleanse`,
    deleteUser: `${USER_ADMIN}/user-id`,
  },
  listing: {
    newPages: `${LISTING_ADMIN}/new-pages`,
    listings: `${LISTING_ADMIN}/listings`,
  },
  event: {
    soldOut: `${EVENT_ADMIN}/sold-out`,
    notSoldBallot: `${EVENT_ADMIN}/not-sold-ballot`,
    eventEnding: `${EVENT_ADMIN}/event-ending`,
    listEvents: `events`,
    getCategories: `categories`,
    getCategory: `categories/category`,
  },
  organisations: {
    getUserOrgs: `organisations`,
  },
};
